import { styled } from "@mui/material";

const Container = styled("header", {
  shouldForwardProp: (prop) =>
    prop !== "showBorderBottom" && prop !== "backGroundColor",
})<{ showBorderBottom: boolean; backGroundColor: string }>`
  display: flex;
  justify-content: space-between;
  padding: ${({ theme }) => theme.spacing(0, 2, 0, 0)};
  align-items: center;
  border-bottom: ${({ showBorderBottom, theme }) =>
    showBorderBottom ? `1px solid ${theme.palette.divider}` : "none"};
  position: relative;
  background-color: ${({ backGroundColor }) => backGroundColor};
`;

const Logo = styled("img")`
  mix-blend-mode: multiply;
`;

const Notch = styled("div")`
  position: absolute;
  bottom: 0px;
  left: 20px;
  width: 24px;
  height: 2px;
  border-radius: 4px;
  background-color: ${({ theme }) => theme.palette.primary.main};
`;

export { Container, Logo, Notch };
